import { render, staticRenderFns } from "./Filtro2.vue?vue&type=template&id=641d57a1"
import script from "./Filtro2.vue?vue&type=script&lang=js"
export * from "./Filtro2.vue?vue&type=script&lang=js"
import style0 from "./Filtro2.vue?vue&type=style&index=0&id=641d57a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports